module.exports = __webpack_public_path__ + "img/projektstarten.7d2f7657.png";